import { Link, useLocation } from 'react-router';

import { useTranslation } from 'react-i18next';

import { Tag, Typography } from '@cfa/react-components';

import { SafeImg } from '@/components/SafeImage';

import Constants from 'constants/index';

interface SubcategoryDocumentProps {
  categoryName?: string;
  className?: string;
  'data-testid'?: string;
  id: string;
  name: string;
  icon?: string | null;
  openInNewTab?: boolean;
  rightSideContent?: React.ReactNode;
  subcategoryName?: string;
  onClick?: () => void;
  onNavigate?: () => void;
}

const SubcategoryDocument = ({
  categoryName: cat,
  id,
  name,
  icon = '',
  onClick,
  onNavigate,
  openInNewTab = false,
  rightSideContent = null,
  subcategoryName: sub,
  'data-testid': DataTestId = '',
  className = '',
}: SubcategoryDocumentProps) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const normalizedIcon =
    !icon || icon === 'placeholder' ? Constants.DEFAULT_PLACEHOLDER_ICON : icon;
  const iconSrc = `${Constants.PATHWAY_CDN_IMG.PROCEDURES}${normalizedIcon}.svg`;
  const fallbackIconSrc = `${Constants.PATHWAY_CDN_IMG.PROCEDURES}${Constants.DEFAULT_PLACEHOLDER_ICON}.svg`;

  return (
    <>
      {onClick ? (
        <button
          type="button"
          className="flex cursor-pointer flex-row items-center justify-between text-left"
          onClick={onClick}
        >
          <div className="group flex flex-row items-center justify-start gap-3 p-4 text-left">
            <SafeImg
              className="w-[30px] rounded-none"
              alt="Document Icon"
              src={iconSrc}
              fallback={fallbackIconSrc}
            />
            <Typography data-testid="SubcategoryDocument" variant="body1">
              {name}
            </Typography>
            <Tag
              className="hidden! group-hover:block!"
              label={t('TrainingPlans.preview')}
            />
          </div>
          {rightSideContent}
        </button>
      ) : (
        <Link
          className={className}
          data-testid={DataTestId}
          onClick={() => {
            onNavigate?.();
          }}
          rel={openInNewTab ? 'noopener noreferrer' : ''}
          target={openInNewTab ? '_blank' : '_self'}
          to={`/doc/${id}?from=browse&backUrl=${encodeURIComponent(pathname)}${cat ? `&cat=${encodeURIComponent(cat)}` : ''}${sub ? `&sub=${encodeURIComponent(sub)}` : ''}`}
        >
          <div className="flex cursor-pointer flex-row items-center justify-between">
            <div className="flex flex-row items-center justify-start gap-3 p-4 text-left">
              <SafeImg
                className="w-[30px] rounded-none"
                alt="Document Icon"
                src={iconSrc}
                fallback={fallbackIconSrc}
              />
              <Typography data-testid="SubcategoryDocument" variant="body1">
                {name}
              </Typography>
            </div>
            {rightSideContent}
          </div>
        </Link>
      )}
    </>
  );
};

export default SubcategoryDocument;
